import {
  isEmpty,
  merge
} from 'lodash'
import Imageable from '@/models/imageable'

class ProjectMeta {

  constructor(meta) {
    this.title = ''
    this.desc = ''
    this.keywords = ''
    this.og = {
      image: new Imageable()
    }
    this.background_image = new Imageable()
    this.background_color = ''
    this.email_subject = ''
    this.email_desc = ''
    this.wt_mc_id = ''
    this.utm_campaign = ''
    this.utm_source = ''
    this.utm_medium = ''
    this.header_src = {
      web: '',
      edm: ''
    }
    this.footer_src = {
      web: '',
      edm: ''
    }

    if (meta) {
      merge(this, meta)
    }
  }

  get anyOGimage() {
    return this.og.image.any
  }

  get isValid() {
    return !isEmpty(this.email_subject) && !isEmpty(this.title)
  }

}

export default ProjectMeta



// WEBPACK FOOTER //
// ./src/models/project/meta.js